module.exports = __webpack_public_path__ + "img/social-facebook.0ed40797.svg";